import firebase from 'firebase';
import moment from 'moment';
import { FirebaseCourseItem } from '../types/types';

export const registerCourse = async (
  course: FirebaseCourseItem,
  currentUser: firebase.User,
  registeredItem:
    | {
        id: string;
        email: string;
        displayName: string;
        clickedTimestamp: string;
      }
    | undefined
) => {
  const ref = firebase.firestore().collection('courses').doc(course.uid);
  await ref.set(
    {
      dates: {
        [moment(course.startMoment).unix()]: registeredItem
          ? firebase.firestore.FieldValue.arrayRemove(registeredItem)
          : firebase.firestore.FieldValue.arrayUnion({
              id: currentUser.uid,
              email: currentUser.email,
              displayName: currentUser.displayName,
              clickedTimestamp: moment().toJSON(),
            }),
      },
    },
    { merge: true }
  );
};
